import ShopifyItemsPage, { productCollections } from './ShopifyItemEditor';
import type { ShopifyProductNode } from '@/lib/shopify';

// Collection-based detection (preferred). Falls back to tag/type for products
// that haven't been added to a collection yet.
const SERVICE_COLLECTION_RE = /(service|שירות|טיפול)/i;
const SERVICE_TOKEN_RE = /(service|שירות|טיפול)/i;

export const isServiceProduct = (p: ShopifyProductNode) => {
  const cols = productCollections(p);
  if (cols.length) {
    const inServiceCol = cols.some(
      (c) => SERVICE_COLLECTION_RE.test(c.handle) || SERVICE_COLLECTION_RE.test(c.title),
    );
    if (inServiceCol) return true;
    // If product is in some collection but not a service collection, treat as product.
    // (Still fall through to tag/type check below for safety.)
  }
  const hasTag = (p.tags ?? []).some((t) => SERVICE_TOKEN_RE.test(t));
  const hasType = !!p.productType && SERVICE_TOKEN_RE.test(p.productType);
  return hasTag || hasType;
};

export default function AdminShopServices() {
  return (
    <ShopifyItemsPage
      title="טיפולים — תוכן ומחיר"
      description='עריכת תוכן עמוד הטיפול בשופיפיי (תמונות, תיאור, מחיר, FAQ). מומלץ לארגן בשופיפיי קולקציה "שירותים"/"Services" — הסינון כאן יזהה אותה אוטומטית.'
      filter={isServiceProduct}
      emptyText='לא נמצאו טיפולים. הוסיפי קולקציה "שירותים" / "Services" בשופיפיי וצרפי אליה את הטיפולים.'
      itemType="service"
    />
  );
}
